<!-- Partnership Benefits Section -->
<section class="flex flex-col items-center gap-12">
  <app-section-header
    icon="@tui.handshake"
    subtitle="Partnership Benefits"
    title="Unlock Your Growth Potential"
    description="Join the Capawesome Partner Network and access exclusive benefits designed to accelerate your business growth and enhance your service offerings"
  />

  <div class="grid w-full grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
    <!-- Priority Support -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.headphones" class="mr-2" />
        <h3 class="text-xl font-bold">Priority Support</h3>
      </div>
      <p class="text-pretty text-lg">
        Get dedicated technical support with faster response times and direct
        access to our engineering team for complex implementations.
      </p>
    </div>

    <!-- Free Access to Capawesome Cloud and Insiders -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.cloud" class="mr-2" />
        <h3 class="text-xl font-bold">Free Development Access</h3>
      </div>
      <p class="text-pretty text-lg">
        Enjoy complimentary access to Capawesome Cloud and Capawesome Insiders
        for your development projects and testing environments.
      </p>
    </div>

    <!-- Roadmap Planning -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.map" class="mr-2" />
        <h3 class="text-xl font-bold">Roadmap Planning</h3>
      </div>
      <p class="text-pretty text-lg">
        Participate in product roadmap discussions and influence future features
        based on your client needs and market insights.
      </p>
    </div>

    <!-- Custom Plugin Development -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.code" class="mr-2" />
        <h3 class="text-xl font-bold">Custom Plugin Development</h3>
      </div>
      <p class="text-pretty text-lg">
        Access to custom plugin development services and collaboration
        opportunities for unique client requirements and specialized solutions.
      </p>
    </div>

    <!-- Affiliate and Referral Program -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.dollar-sign" class="mr-2" />
        <h3 class="text-xl font-bold">Affiliate & Referral Program</h3>
      </div>
      <p class="text-pretty text-lg">
        Earn commissions through our private affiliate program and receive
        referral bonuses for bringing new customers to the Capawesome ecosystem.
      </p>
    </div>

    <!-- Promotion -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.trending-up" class="mr-2" />
        <h3 class="text-xl font-bold">Promotion</h3>
      </div>
      <p class="text-pretty text-lg">
        Get featured in our partner spotlights, case studies, and marketing
        materials to enhance your brand visibility and credibility.
      </p>
    </div>
  </div>
</section>
